import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=6333ecb8&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=ts"
export * from "./ContactDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6333ecb8",
  null
  
)

export default component.exports